var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKustomLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    viewBox: "0 0 4116 679",
    fill: "none",
    className: "footer_logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9326_305)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9326_305",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 4116,
    height: 679
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4115.31 0H0V678.926H4115.31V0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9326_305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1181.45 457.529C1181.45 475.351 1166.79 489.138 1149.05 489.138C1130.2 489.138 1115.62 475.272 1115.62 457.529V168.96H850.109V493.093C850.109 615.636 917.042 678.846 1027.86 678.846C1102.56 678.846 1158.16 652.707 1188.9 612.231V663.005H1447.13V168.96H1181.61V457.529H1181.45Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1732.84 320.177C1732.84 304.333 1744.09 297.443 1763.42 297.443C1782.74 297.443 1798.11 310.274 1798.11 336.021H2028.86C2028.86 260.921 1983.94 152.246 1752.41 152.246C1589.23 152.246 1486.18 215.456 1486.18 315.265C1486.18 522.802 1786.31 444.698 1786.31 510.921C1786.31 525.729 1774.03 533.655 1754.71 533.655C1732.29 533.655 1717.95 517.811 1717.95 494.128H1481.03C1484.12 618.649 1593.27 678.928 1756.45 678.928C1898.24 678.928 2044.15 647.328 2044.15 509.975C2044.15 318.282 1732.76 386.483 1732.76 320.259L1732.84 320.177Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.223 350.83L820.723 160.086L608.508 0L422.436 223.375V26.7H150.58V219.419H0V457.609H150.58V663.161H422.436V468.461C491.436 523.832 530.091 588.07 544.736 663.161H840.6C817.627 542.603 754.9 438.837 649.3 350.909L649.223 350.83Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2390.3 49.4302H2123.68V169.039H2047.31V336.021H2123.68V469.41C2123.68 599.872 2200.03 663.088 2354.74 663.088H2493.76V463.469H2416.36C2400.68 463.469 2390.22 452.617 2390.22 437.808V336.021H2493.76V169.039H2390.22V49.4302H2390.3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2838.8 461.963C2812.66 461.963 2792.79 441.685 2792.79 414.996C2792.79 388.307 2812.66 369.051 2838.8 369.051C2864.93 369.051 2883.8 389.329 2883.8 414.996C2883.8 440.663 2863.91 461.963 2838.8 461.963ZM2837.77 152.163C2653.76 152.167 2525.2 258.866 2525.2 414.042C2525.2 569.218 2648.53 678.842 2836.74 678.842C3024.95 678.842 3150.42 572.142 3150.42 414.042C3150.42 255.942 3023.93 152.167 2837.85 152.167L2837.77 152.163Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3924.01 152.167C3863.49 152.167 3797.9 167.533 3761.94 225.99C3732.47 177.675 3682.96 152.167 3621.89 152.167C3548.07 152.167 3491.03 175.85 3453.57 233.756V168.956H3194.31V663.082H3457.76V390.357C3457.76 373.564 3472.42 359.705 3491.19 359.705C3508.93 359.705 3523.59 373.564 3523.59 390.357V663.082H3784.99V390.357C3784.99 373.564 3799.64 359.705 3818.42 359.705C3836.16 359.705 3850.82 373.564 3850.82 390.357V663.082H4115.31V336.015C4115.31 226.309 4037.92 152.247 3924.01 152.247L3924.01 152.167Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9326_305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4115.31,
    height: 678.926,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKustomLogo);
export default __webpack_public_path__ + "static/media/kustom-logo.8e86e7e1f83de26da1c768431cb3bf08.svg";
export { ForwardRef as ReactComponent };